var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 327.9 104.6",
    style: {
      enableBackground: "new 0 0 327.9 104.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.1577,
    y1: -21.0782,
    x2: 50.0246,
    y2: 86.6248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,65.4c0.7,1.3,2.1,1.6,3.3,0.7l20.5-15.3c1.1-0.8,1.3-2.4,0.2-3.4L30.1,33.1c-1-1-3-2.1-4.4-2.4L4.4,26 c1.1,4.4,1.9,9,2.4,13.6L20.5,65.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.4026,
    y1: -4.771,
    x2: 21.7797,
    y2: 102.932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.9,74.1l-4.3-0.8C5,76,4.4,78.6,3.7,81.1l6.6-4.9C11.5,75.3,11.3,74.4,9.9,74.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.9693,
    y1: -9.0626,
    x2: 29.2131,
    y2: 98.6404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,68L7.6,52c0,5.4-0.4,10.9-1.1,16.2l8.3,1.5C16.1,70,16.7,69.2,16,68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.8133,
    y1: -20.6997,
    x2: 49.369,
    y2: 87.0033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.3,25.2L2.8,5.7c-2.4,4-2.5,10,0.6,16.8l18.1,3.9C23,26.8,23.3,26.2,22.3,25.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.894,
    y1: -32.6551,
    x2: 70.0764,
    y2: 75.0479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.9,29.6l26.2,5.7c1.4,0.3,3.5-0.1,4.6-1l0.9-0.7C53.4,22.7,39.1,12.8,23.3,4.1c-6.8-4-12.8-4.2-16.8-2 l25.1,25.1C32.6,28.2,34.6,29.3,35.9,29.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.0823,
    y1: -33.3411,
    x2: 71.2646,
    y2: 74.3619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.7,37.8l-18.5-4c-1.4-0.3-1.7,0.3-0.7,1.3l9.3,9.3c1,1,2.8,1.1,3.9,0.3l6.4-4.8 C60.3,39.1,60.1,38.1,58.7,37.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.1455,
    y1: -18.1985,
    x2: 45.0368,
    y2: 89.5045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M28.1,79.6l7.4,13.8C41.3,89.8,47,86,52.6,82l-23.2-4.3C28,77.5,27.4,78.3,28.1,79.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.6166,
    y1: -23.7,
    x2: 54.5658,
    y2: 84.003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51.9,54.9c-1-1-2.8-1.1-3.9-0.3L27.1,70.1c-1.1,0.8-0.9,1.8,0.5,2l30.9,5.7c3.2-2.3,6.3-4.7,9.4-7.1 L51.9,54.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5228,
    y1: -38.2143,
    x2: 79.7052,
    y2: 69.4887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.8,41.4l-9.5,7c-1.1,0.8-1.3,2.4-0.2,3.4l15.9,15.9c10-7.4,11.3-17.5,4.8-25.9l-6.4-1.4 C69,40.1,67,40.5,65.8,41.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.4023,
    y1: -4.1938,
    x2: 20.78,
    y2: 103.5092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C42A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    style: {
      stopColor: "#922C88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    style: {
      stopColor: "#A02D6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    style: {
      stopColor: "#F3506F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9851,
    style: {
      stopColor: "#FCB450"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.9,76c-0.3-0.1-1.4,0.6-2.6,1.4l-16.1,12c-1.6,12.2,8.5,19.1,22.1,11.1c2.6-1.4,5.2-2.9,7.7-4.4l-9.4-17.7 C20.9,77.1,20.1,76,19.9,76z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.2,47.7h9.6v18.8c-5.2,3.8-13.1,6.4-19.9,6.4c-14.8,0-26.1-10.8-26.1-25c0-14.1,11.5-24.9,26.7-24.9 c7.3,0,14.7,2.8,19.7,7.1l-6.2,7.9c-3.6-3.4-8.7-5.5-13.4-5.5c-8.7,0-15.4,6.7-15.4,15.3c0,8.7,6.8,15.3,15.5,15.3 c2.9,0,6.4-1,9.6-2.7V47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6,47.9c0,14.1-11.3,25-26.3,25s-26.3-10.8-26.3-25c0-14.3,11.3-24.9,26.3-24.9S219.6,33.7,219.6,47.9z M178.3,47.9 c0,8.6,6.9,15.3,15.1,15.3c8.2,0,14.8-6.7,14.8-15.3c0-8.6-6.7-15.2-14.8-15.2C185.1,32.8,178.3,39.3,178.3,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5,47.7h9.6v18.8c-5.2,3.8-13.1,6.4-19.9,6.4c-14.8,0-26.1-10.8-26.1-25c0-14.1,11.5-24.9,26.7-24.9 c7.3,0,14.7,2.8,19.7,7.1l-6.2,7.9c-3.6-3.4-8.7-5.5-13.4-5.5c-8.7,0-15.4,6.7-15.4,15.3c0,8.7,6.8,15.3,15.5,15.3 c2.9,0,6.4-1,9.6-2.7V47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.9,47.9c0,14.1-11.3,25-26.3,25s-26.3-10.8-26.3-25c0-14.3,11.3-24.9,26.3-24.9S326.9,33.7,326.9,47.9z M285.6,47.9 c0,8.6,6.9,15.3,15.1,15.3c8.2,0,14.8-6.7,14.8-15.3c0-8.6-6.7-15.2-14.8-15.2C292.4,32.8,285.6,39.3,285.6,47.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack);
export default __webpack_public_path__ + "static/media/black.e27080da98a1aceafd12edfb3f414e6d.svg";
export { ForwardRef as ReactComponent };